// src/App.jsx
import React from "react";
import { useEffect, useState } from "react";
import img2 from "../Assets/pic16-1-700x400.jpg"
import img1 from "../Assets/pic17-700x400.jpg"
import img3 from "../Assets/pic18-1-700x400.jpg"





function Biomimetics() {


    return (
        <div className="min-h-screen bg-white">


            <div className="flex flex-col items-center  min-h-screen p-4 w-full font-serif">
                <p className="text-3xl text-gray-700 mb-2">
                    BIOMECHANICAL CHARACTERIZATION OF SPIDER WEBS
                </p>

                <p className="text-1xl mb-2">
                    The spider webs have become point of interest of researchers around the world because of its amazing architecture and behaviour. This architecture has unique combination of geometry and mechanics which lead it to sustain under windy condition, storm condition also in high humid environment. Also, the spider web can capture the flying prey having high kinetic energy, also be able to withstand this high kinetic energy imparted on it during capture. These wonderful phenomenon drive us to study the insights of the spider webs. We have potentially performed the experiments on spider web utilizing different basic mechanical principles, scanning electron microscopy, nanomechanical tools and laser vibrometry. The on field vibration damping experiment was performed to visualize the behaviour of the web under windy condition. The spider web consist of two different major types of silk threads radial silk thread and spiral silk thread. In the Figure these are exhibited along with their scanning electron micrographs. The radial silk threads have larger diameter than the spiral silk threads and onto the spiral silk threads the gum spots are distinctive. Also the joints of two threads are very clear in this micrograph. The load versus penetration for quasistatic nanoindentation analysis also exhibited in Figure. The nanomechanical analysis reveals that the radial silk thread has higher strength and has taken the key role to maintain the structural integrity of the whole webs. The prey is captured by the gum spot of the spiral silk threads. The time decay waveforms of the both radial and spiral silk thread under the action of wind induced vibration are captured by laser vibration and are shown in Figure. Through nanomechanical analysis, we have determined that the spiral silk threads have high flexibility and damping characteristic; it can deform easily during prey capture and distributes the imparted high kinetic energy into the whole web. Thus spiral silk threads combat instantly against the high kinetic energy of the flying prey. The architecture and behaviour of the spider web are very inspiring to artificially mimetic this structure with suitable geometry which is predicted to be used as a protective bullet proof wear in military applications also as surgical sutures for doctors. The silk materials, which is a very smart protein materials can be used in tissue engineering applications. The mimetic of this type of wonderful natural materials/ behaviour is called Biomiemetics, the very new emerging field in which taking lessons from nature the skilled researchers from all over the world are developing cutting edge technology for the society. This current research of spider web has been recently published in the Journal of the Mechanical Behaviour of Biomedical Materials [Volume 67, Page 101–109, 2017] of the Elsevier publishing, UK.

                </p>
                <img
                    src={img1}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4"
                />

                <div className="w-full h-1 border border-black"></div>

                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    BIO MECHANICAL CHARACTERIZATION OF SPIDER WEBS :
                </p>


                <p className="text-1xl mb-2">
                    The flight of dragonfly attracts the considerable attention in aerodynamics because of its amazing behaviour. The dragonflies, the versatile fliers are capable of manoeuvrable flying and gliding flying up to 30 sec without any notable change of altitude. The in depth knowledge about its biomechanical properties of wings can provide significant input for biomimetic design of Micro Air Vehicles (MAVs). The MAV works in numerous important military and civil applications through sensing and gathering information, such as surveillance, rescue, environment monitoring etc. The mode shape and strain distribution of the dragonfly forewing at its flapping is shown in Figure.

                </p>

                <img
                    src={img2}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />

                <div className="w-full h-1 border border-black"></div>


                <p className="text-3xl text-gray-700 mb-2 mt-4">
                    BIOMECHANICAL AND PENETRATION BEHAVIOUR OF INSECT STINGERS:
                </p>


                <p className="text-1xl mb-2">
                    The structures, properties and insertion mechanics of insect stingers (wasp, honey bee, scorpion stingers etc) have been enthused researchers to fabricate bio-inspired microneedle. These biomemetic microneedles fabricated utilizing polymeric or silicon materials have superiority over artificial microneedles like painless insertion and removal, minimal insertion force and soft tissue adhesion without any damage. In our present study, the nanomechanical properties of the wasp and honey bee stingers have been determined also the penetration behavior of the stingers has been numerically investigated. The stress distribution of the honey bee stinger under different compressive force which mimics its behavior during penetration into human skin is exhibited in Figure.



                </p>

                <img
                    src={img3}
                    alt="img1"
                    className="rounded shadow mb-4 mt-4" />




            </div>




        </div>
    );
}

export default Biomimetics;
